import React from 'react';

import HomeNav from '../components/HomeNav.jsx';
import { useSelector } from 'react-redux';
import { userPermissions } from './UserDashboard.jsx';

const Home = () => {
    const session = useSelector((state) => state.session);
    const isReadOnly = (session?.permissions || []).includes(userPermissions.READONLY);
    return (
        <>
            {!isReadOnly && <HomeNav />}
            <div className="container">
                <p>Welcome to the Playaway Admin Panel.</p>
            </div>
        </>
    );
};

export default Home;
